import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getUrlQuerysection, isSellMode } from "../../../../../helpers";
import { useStoreCurrency } from "../../../../../hooks/useStoreCurrency";
import { useSelector } from "react-redux";
import { useGetReconciliations } from "../../../../../hooks/api/queries";
import { useStartReconciliations } from "../../../../../hooks/api/mutations/useInventory";
import { pathConstants } from "../../../../../routes/pathContants";

const useAllReconciliations = () => {
  const queries = getUrlQuerysection();
  const [isOpenReconciliation, setIsOpenReconciliation] = useState(false);
  const [search, setSearch] = useSearchParams();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { storeHasMultipleCurrency } = useStoreCurrency();
  const navigate = useNavigate();

  const {
    isLoading: isFetchingReconciliations,
    data: reconciliations,
    refetch: handleFetchReconciliations,
  } = useGetReconciliations({ queries });

  const { mutate: beginReconcile, isLoading: isStartingReconcile } =
    useStartReconciliations();
  const reconcile = (data) => {
    beginReconcile(data, {
      onSuccess: (res) => {
        setIsOpenReconciliation(false);
        navigate(
          pathConstants.INVENTORY_RECONCILIATIONS_EDIT({
            store_id: res?.data?.data?.store?.id,
            id: res?.data?.data?.id,
            isSellMode: isSellMode(),
          }) + `?store_id=${res?.data?.data?.store?.id}`,
        );
      },
    });
  };

  const filterByStoreId = (storeId) => {
    if (storeId === "ALL_STORES") search.delete("store_id");
    else search.set("store_id", storeId);
    setSearch(search, { replace: true });
  };

  const gotoPage = (pageNumber) => {
    search.set("page", pageNumber);
    setSearch(search, { replace: true });
  };

  return {
    isFetchingReconciliations,
    isStartingReconcile,
    reconciliations: reconciliations?.data || [],
    metaDetails: reconciliations?.meta,
    storeList,
    storeHasMultipleCurrency,
    isOpenReconciliation,
    search,
    reconcile,
    setSearch,
    filterByStoreId,
    handleFetchReconciliations,
    setIsOpenReconciliation,
    gotoPage,
  };
};
export default useAllReconciliations;
